import React, { useState } from "react";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import ConfirmModal from "./ConfirmModal";
import {
  EDITED_SUCCESS_MSG,
  ERROR_MSG,
} from "../../../../core/data/constants/constant";
import LeadApi from "../api/LeadApi";
import { MODULES } from "../../../../core/data/constants/moduleConstants";
import { all_routes } from "../../../router/all_routes";
import { useStages } from "../../../crmSetting/stages/hooks/useStages";
import {
  getAllUrlParams,
  setUrlParams,
} from "../../../../utils/helpers/setAndGetUrlParams";
import {
  updateLeadsListCache,
  updateSingleLeadCache,
} from "../actions/updateLeadsListCache";
import { useDispatch, useSelector } from "react-redux";
import { generateQueryParams } from "../../../../utils/helpers/generateQueryParams";
import { useSearchParams } from "react-router-dom";
import { setRefetchFlag } from "../../../../core/data/redux/moduleDataSlice";
import { exec } from "apexcharts";

const LeadPipelineStatus = ({ leadData }) => {
  const route = all_routes;
  const [searchParams, setSearchParams] = useSearchParams();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedStage, setSelectedStage] = useState({});
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const urlParams = getAllUrlParams();
  const dispatch = useDispatch();

  const { filters } = useSelector((state) => state.filter);
  const leadsFilters = filters.leads || [];
  let { queryParams, params } = generateQueryParams(leadsFilters);

  const { stagesData, isLoading } = useStages({
    ofCompany: leadData?.ofCompany?._id,
    module: MODULES.LEADS,
  });

  const stages = stagesData?.data?.data;

  const { currentStatus: currentStage } = leadData || {};

  const mutationUpdate = useMutation({
    mutationFn: ({ id, updatedStage }) =>
      LeadApi.updateLead(id, {
        currentStatus: updatedStage,
        textMessageAboutActivity: `<b>${MODULES.LEADS.slice(
          0,
          -1
        )} currentStatus</b> updated from <b>${currentStage?.name}</b> to <b>${
          updatedStage?.name
        }</b>`,
      }),
    onMutate: async ({ id, updatedStage }) => {
      await queryClient.cancelQueries(["lead", id]);

      const previousLead = queryClient.getQueryData(["lead", id]);

      updateSingleLeadCache(leadData?._id, {
        ...previousLead,
        currentStatus: updatedStage,
      });
      console.log("updatedStage", updatedStage);
      

    

      updateLeadsListCache({
        id: leadData?._id,
        updatedData: { ...previousLead, currentStatus: updatedStage },
        page: urlParams?.page * 1,
        limit: urlParams?.limit * 1,
        queryString: params?.toString(),
        queryParams: queryParams?.toString(),
        companyId: urlParams?.companyid,
      });

      return { previousLead };
    },
    onSuccess: (response) => {
      if (response?.status) {
        toast.success(EDITED_SUCCESS_MSG);
        updateSingleLeadCache(leadData?._id, response?.data);

        updateLeadsListCache({
          id: leadData?._id,
          updatedData: response?.data,
          page: urlParams?.page * 1,
          limit: urlParams?.limit * 1,
          queryString: params?.toString(),
          queryParams: queryParams?.toString(),
          companyId: urlParams?.companyid,
        });
      }

      if (response.status && response?.msg) {
        toast.success(response.msg);

        if (response?.msg && response?.data?.leadToDealOn) {
          navigate(route.deals);
          dispatch(setRefetchFlag({ module: "deals", flag: true }));
          queryClient.invalidateQueries(["leads"]);
        }
      }

      // queryClient.invalidateQueries("leads");
    },
    onError: (error, _, context) => {
      toast.error(error.response?.data?.msg || ERROR_MSG);
      // ✅ Rollback to previous state on error
      if (context?.previousLead) {
        queryClient.setQueryData(["lead", leadData?._id], context.previousLead);
      }
    },
  });

  const handleStageChange = (stage) => {
    if (stage?.id === currentStage?.id) {
      toast.warning("You are already on this stage!");
      return;
    }

    setSelectedStage(stage);
    if (stage?.toDeal) {
      setShowConfirmModal(true);
    } else {
      mutationUpdate.mutate({ id: leadData?._id, updatedStage: stage });
    }
  };

  const handleConfirm = () => {
    mutationUpdate.mutate({ id: leadData?._id, updatedStage: selectedStage });
    setShowConfirmModal(false);
  };

  return (
    <div className="col-md-12">
         

      <div className="row mb-3" style={{ margin: "0 2px" }}>
        <div className="card mb-3">
          <div className="card-body p-0 mt-2">
            <h5 className="fw-semibold mb-3">Lead Pipeline Status</h5>
            <div className="d-flex flex-wrap pipeline-list">
              {isLoading || mutationUpdate?.isPending
                ? // Render dummy stages when loading
                  Array(7)
                    .fill(null)
                    .map((_, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center stage-container position-relative "
                      >
                        <div
                          className="px-2 py-1 rounded-pill text-white 
                                                   d-flex align-items-center mb-3 text-capitalize"
                          style={{
                            width: "5rem",
                            height: "2rem",
                            backgroundColor: "lightgray",
                            cursor: "default",
                            transition: "all 0.2s ease-in-out",
                          }}
                        ></div>
                        {index < 6 && (
                          <div
                            className="d-flex align-items-center h-100 position-relative"
                            style={{
                              transform: "translateY(-6px)",
                            }}
                          >
                            <HiOutlineArrowNarrowRight
                              size={25}
                              className="stage-arrow"
                              color="lightgray"
                            />
                          </div>
                        )}
                      </div>
                    ))
                : stages?.map((stage, index) => (
                    <div
                      key={stage?.id}
                      className="d-flex align-items-center stage-container position-relative"
                    >
                      <div
                        className={`
                  px-2 py-1 rounded-pill text-white 
                  d-flex align-items-center mb-3 text-capitalize
                  ${
                    stage?.id === currentStage?.id
                      ? "shadow-lg active-stage"
                      : "inactive-stage"
                  }
                `}
                        style={{
                          backgroundColor: stage?.color,
                          cursor: "pointer",
                          transition: "all 0.2s ease-in-out",
                        }}
                        onClick={() => handleStageChange(stage)}
                         data-bs-toggle={`${stage?.postAction?.autoOpenReminder && "modal"}`}
                      data-bs-target={`${stage?.postAction?.autoOpenReminder ? "#setReminderModal" : ""} `}
                      >
                        <span className="stage-name">{stage?.name}</span>
                      </div>
                      {index < stages?.length - 1 && (
                        <div
                          className="d-flex align-items-center h-100 position-relative"
                          style={{ transform: "translateY(-6px)" }}
                        >
                          <HiOutlineArrowNarrowRight
                            size={25}
                            className="stage-arrow"
                          />
                        </div>
                      )}
                    </div>
                  ))}
            </div>
          </div>
          <ConfirmModal
            open={showConfirmModal}
            onClose={() => setShowConfirmModal(false)}
            onConfirm={handleConfirm}
            selectedStage={selectedStage}
          />
          {/* <SetReminderModal data={leadData} module="lead" /> */}

      
         
        </div>
      </div>
    </div>
  );
};

export default LeadPipelineStatus;
